import React from "react";
import { LOGOUT_OWNER } from "../../actions/mutations";
import { useMutation } from "@apollo/client";
import { useNavigate, Link } from "react-router-dom";
import Cookies from "js-cookie";

const Navbar_account = ({ title, isActive, cta }) => {
  const [logoutOwner] = useMutation(LOGOUT_OWNER);

  const navigate = useNavigate();
  return (
    <nav id="navbar">
      <Link className="logo logoHeader" to="/#">
      <img src="/images/logo.png" alt=""></img>

      </Link>
      <h1 id="accountTitle">
        {title}
        <span
          id={
            isActive === "hidden"
              ? ""
              : isActive
              ? "activeAccount"
              : "inactiveAccount"
          }
        >
          {isActive === "hidden" ? "" : isActive ? "activé" : "désactivé"}
        </span>
      </h1>
      {cta === "no" ? (
        ""
      ) : (
        <button
          id="accountLogout"
          onClick={() => {
            // deleteToken()
            logoutOwner()
              .then(() => {
                // deleteToken()
                // navigate('/login')
                Cookies.remove("subTok");
                sessionStorage.removeItem("loggedIn");
                navigate("/login");
                window.location.reload();
              })
              .catch((e) => {
                console.log(e.message);
              });
          }}
        >
          Se déconnecter
        </button>
      )}
    </nav>
  );
};

export default Navbar_account;
